import ReactJsonView from "@microlink/react-json-view";
import { UnfoldLess, UnfoldMore } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { FC } from "react";
import Highlighter from "react-highlight-words";
import { useTranslation } from "react-i18next";

import { FullInfoTabToolbar } from "./ai-conversation-details.styled";
import { JSON_STRINGIFY_INDENT } from "./ai-conversation.constants";

interface IAiConversationDetailsTreeviewProps {
  fullInfoSrc: unknown[];
  searchTerm?: string;
  expandedAll: boolean;
  onExpandAll: () => void;
  onCollapseAll: () => void;
}

export const AiConversationDetailsTreeview: FC<
  IAiConversationDetailsTreeviewProps
> = ({ fullInfoSrc, searchTerm, expandedAll, onExpandAll, onCollapseAll }) => {
  const { t } = useTranslation();

  return (
    <>
      {fullInfoSrc.length > 0 && !searchTerm && (
        <FullInfoTabToolbar>
          <Tooltip title={t("aiAdvisor.expandAll")}>
            <IconButton
              size="small"
              onClick={onExpandAll}
              aria-label={t("aiAdvisor.expandAll")}
              sx={{ cursor: "pointer" }}
            >
              <UnfoldMore fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("aiAdvisor.collapseAll")}>
            <IconButton
              size="small"
              onClick={onCollapseAll}
              aria-label={t("aiAdvisor.collapseAll")}
              sx={{ cursor: "pointer" }}
            >
              <UnfoldLess fontSize="small" />
            </IconButton>
          </Tooltip>
        </FullInfoTabToolbar>
      )}
      {fullInfoSrc.length === 0 && <span>—</span>}
      {fullInfoSrc.length > 0 && (
        <div className="full-info-tab-scroll-area">
          {(() => {
            const jsonTextToHighlight =
              fullInfoSrc.length === 1
                ? JSON.stringify(fullInfoSrc[0], null, JSON_STRINGIFY_INDENT)
                : JSON.stringify(fullInfoSrc, null, JSON_STRINGIFY_INDENT);

            if (searchTerm) {
              return (
                <pre>
                  <Highlighter
                    searchWords={[searchTerm]}
                    autoEscape={true}
                    textToHighlight={jsonTextToHighlight}
                    highlightClassName="search-highlight"
                  />
                </pre>
              );
            }
            if (fullInfoSrc.length === 1) {
              return (
                <ReactJsonView
                  src={fullInfoSrc[0] as object}
                  name={false}
                  displayDataTypes={false}
                  collapsed={expandedAll ? false : 1}
                  theme="rjv-default"
                  style={{ backgroundColor: "transparent", fontSize: 13 }}
                />
              );
            }
            return (
              <ReactJsonView
                src={fullInfoSrc as object[]}
                name={false}
                displayDataTypes={false}
                collapsed={expandedAll ? false : 1}
                theme="rjv-default"
                style={{ backgroundColor: "transparent", fontSize: 13 }}
              />
            );
          })()}
        </div>
      )}
    </>
  );
};
